export function getAdjustedTimeSegment(segment){
    return segment < 10 ? "0"+segment : segment;
}